// Lines Shopify's account popover up with the account icon: the popover is fixed 20px from the window's
// right edge, which on wide screens is far from the icon inside the centred header. Sets
// --lytes-account-right (read in lytes.css).
(function () {
  function place() {
    var account = document.querySelector('header-actions shopify-account');
    if (!account) return;
    var gap = Math.round(window.innerWidth - account.getBoundingClientRect().right);
    document.documentElement.style.setProperty('--lytes-account-right', Math.max(12, gap - 8) + 'px');
  }
  function start() {
    place();
    window.addEventListener('resize', place);
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('shopify-account')) place();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
